import { render, staticRenderFns } from "./PolicyManagement.vue?vue&type=template&id=66bb199e&scoped=true&"
import script from "./PolicyManagement.vue?vue&type=script&lang=js&"
export * from "./PolicyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb199e",
  null
  
)

export default component.exports